import { FunctionComponent } from 'react';
import {Modal, Image} from 'react-bootstrap';
import cn from 'classnames';
import styles from "./AddUpdateUser.module.css";
import CustomButton, { ButtonRadiusSize, ButtonSize, ButtonType } from '../../../../../../../component/common/CustomButton/CustomButton';
import FormField, { IFieldTheme, IFieldType } from '../../../../../../../component/common/FormField/FormField';
import FormSelect from '../../../../../../../component/common/FormField/FormSelect';
import { ASSESTS } from '../../../../../../../constant/assest';

interface IProps {
    showModal: boolean;
    title: string;
    onClose: () => void;
    className?: string;
};

const AddUpdateUser: FunctionComponent<IProps> = ({showModal, title, onClose, className}) => {
  return (
    <Modal 
        show={showModal} 
        className={cn(styles.addModal, className)}
        dialogClassName={styles.addModalDialog}
        contentClassName={styles.addModalContent}
        centered={true}
    >
        <CustomButton
            className={styles.modalCloseBtn}
            btnType={ButtonType.IMAGE}
            onClick={onClose}
        >
            <Image src={ASSESTS.CLOSEPOPUP}  alt="Close" />
        </CustomButton>
        <Modal.Header bsPrefix={styles.header}>
          <Modal.Title bsPrefix={styles.title} as={'div'}>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body bsPrefix={styles.body}>
            <div className={styles.formTwoCol}>
                <div className={styles.formCol}>
                    <FormField 
                        label={'Full Name'}
                        placeholder='Enter Name'
                        fieldType={IFieldType.TEXT}
                        fieldTheme={IFieldTheme.LIGHT}
                    />
                </div>
                <div className={styles.formCol}>
                    <FormSelect
                        label={'Role'}
                        fieldTheme={IFieldTheme.LIGHT2}
                        placeholder='Select Role'
                    >
                        <option value="support">Support</option>
                        <option value="editor">Editor</option>
                        <option value="admin">Admin</option>
                    </FormSelect>
                </div>
            </div>
            <div className={styles.fullField}>
                <FormField 
                    label={'Email Address'}
                    placeholder='Enter Email Address'
                    fieldType={IFieldType.TEXT}
                    fieldTheme={IFieldTheme.LIGHT}
                />
            </div>
            <div className={styles.fullField}>
                <FormSelect
                    label={'Permissions'}
                    placeholder='Select Permission'
                    fieldTheme={IFieldTheme.LIGHT2}
                >
                    <option value="Access1">Access 1</option>
                    <option value="Access2">Access 2</option>
                    <option value="FullAccess3">Full Access</option>
                </FormSelect>
            </div>
        </Modal.Body>
        <Modal.Footer bsPrefix={styles.footer}>
            <CustomButton
                className={styles.addBtn}
                btnType={ButtonType.GREEN}
                btnRadius={ButtonRadiusSize.SMALL}
            >
                Add User
            </CustomButton>
            <CustomButton
                className={styles.addMoreBtn}
                btnType={ButtonType.LIGHTBLUE}
                btnRadius={ButtonRadiusSize.SMALL}
            >
                Add More
            </CustomButton>
        </Modal.Footer>
    </Modal>
  );
}

export default AddUpdateUser;